module.exports = __webpack_public_path__ + "img/tapiratiba.3f274433.png";